import { http } from "./http";

const FEMA_WORKER_URL =
  "https://femasync.lucas-lmirr-9c6.workers.dev/api/fema/sync";

export const auctionPropertiesApi = {
  list: (params) =>
    http.get("/auction-properties", { params }).then((r) => r.data),

  getById: (id) =>
    http.get(`/auction-properties/${id}`).then((r) => r.data.data),

  create: (payload) =>
    http.post("/auction-properties", payload).then((r) => r.data.data),

  update: (id, payload) =>
    http.put(`/auction-properties/${id}`, payload).then((r) => r.data.data),

  syncFema: ({ latitude, longitude }) =>
    fetch(FEMA_WORKER_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ latitude, longitude }),
    }).then(async (response) => {
      const data = await response.json();

      if (!response.ok || !data?.success) {
        throw new Error(data?.error || "Erro ao consultar proxy FEMA");
      }

      return data.data;
    }),
  syncRegrid: (id) =>
    http.post(`/auction-properties/${id}/sync-regrid`).then((r) => r.data.data),
};
